<template>
  <div class="filter-container">
    <vs-button color="secondary" type="border" class="h-full" @click="isShow = !isShow"><feather-icon icon="FilterIcon" style="width: 20px; height: 20px" class="align-bottom" /> 필터 </vs-button>
    <vx-card v-show="isShow" class="content" :class="addFilterType === 'buttons' ? 'buttons-width' : 'logical-width'" style="z-index: 1000">
      <!-- HEAD -->
      <div class="flex items-center justify-between">
        <p class="title">필터</p>
        <button class="none-style" @click="isShow = false"><feather-icon icon="XIcon" style="width: 20px; height: 20px" class="align-bottom" /></button>
      </div>
      <!-- BODY -->
      <div class="body flex flex-col gap-3 my-3">
        <fragment v-for="(filterData, filterData_i) in filterDatas" :key="`filterData_${filterData_i}`">
          <FilterButtonType v-if="filterData.type === 'type'" :options="typeOptions" v-model="filterData.value" />
          <component v-else :is="addComponent" :label="`필터 ${filterData_i}`" :options="addOptions" v-model="filterData.value" @delete="deleteFilter(filterData_i)" />
        </fragment>
        <button v-if="enabledAddOption" style="color: #7e72f2" class="w-24 py-2 none-style" @click="addFilter"><feather-icon icon="PlusIcon" style="width: 20px; height: 20px" class="align-top mr-1" />필터 추가</button>
      </div>
      <!-- Foot -->
      <div class="flex justify-end gap-3">
        <vs-button color="secondary" type="border" @click="isShow = false"> 닫기 </vs-button>
        <vs-button color="secondary" type="border" @click="resetFilterDatas"> 초기화 </vs-button>
        <vs-button color="secondary" @click="finishFilter"> 적용 </vs-button>
      </div>
    </vx-card>
  </div>
</template>

<script>
import FilterButtonType from "./FilterButtonType.vue";
import FilterButtonButtons from "./FilterButtonButtons.vue";
import FilterButtonLogical from "./FilterButtonLogical.vue";

export default {
  components: { FilterButtonType, FilterButtonButtons, FilterButtonLogical },
  props: {
    addFilterType: {
      type: String,
      default: "buttons",
    },
    typeOptions: {
      type: Array,
      default: () => [],
    },
    addOptions: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
    // 필터 추가 버튼 활성화 여부 (true 일 경우, "추가" 버튼이 표시됨)
    enabledAddOption: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isShow: false,
      filterDatas: this.value,
    };
  },
  computed: {
    addComponent() {
      if (this.addFilterType === "buttons") return FilterButtonButtons;
      else if (this.addFilterType === "logical") return FilterButtonLogical;
    },
  },
  watch: {
    value: {
      handler(value) {
        if (value.length === 0) this.resetFilterDatas();
        else this.filterDatas = value;
      },
    },
  },
  methods: {
    addFilter() {
      if (this.addFilterType === "buttons") this.filterDatas.push({ type: "buttons", value: { selectType: "전체", buttonInput: "이행" } });
      else if (this.addFilterType === "logical") this.filterDatas.push({ type: "logical", value: { selectType: this.addOptions[0].label, selectLogical: "포함", customInput: "" } });
    },
    deleteFilter(index) {
      this.filterDatas.splice(index, 1);
    },
    resetFilterDatas() {
      this.filterDatas = [{ type: "type", value: this.typeOptions }];
    },
    finishFilter() {
      this.isShow = false;
      this.$emit("input", this.filterDatas);
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-container {
  position: relative;
  height: 38px;

  & > .content {
    position: absolute;
    top: calc(100% + 56px);
    left: 0;
    z-index: 100;

    &.buttons-width {
      width: 592px;
    }
    &.logical-width {
      width: 780px;
    }

    .title {
      font-size: 17px;
      font-weight: 500;
    }
    .body {
      padding: 7px 17px;
      border-width: 1px 0px 1px 0px;
      border-style: solid;
      border-color: #7e72f20d;
    }

    button.none-style {
      cursor: pointer;
      background: none;
      border: none;
    }
  }
}
</style>
